import React from 'react';
import { Row, Col, Form, Input, InputNumber } from "antd";
import UploadFile from "@general/UploadFile";

const ConsultationInputs = ({error}) => {
    return (
        <Row gutter={15}>
        <Col xs={24} lg={12}>
          <Row gutter={15}>
            <Col xs={24} md={12}>
              <Form.Item
                name="name"
                label="نام خدمت"
                rules={[
                  {
                    required: true,
                    message: "لطفا نام خدمت را وارد کنید!",
                  },
                ]}
                validateStatus={error && "error"}
              >
                <Input className="form-input" placeholder="نام خدمت" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
            <Form.Item
                name="image"
                label="پوستر"
                rules={[
                  {
                    required: true,
                    message: "لطفا تصویر مشاوره آپلود کنید!",
                  },
                ]}
                validateStatus={error && "error"}
              >
                <UploadFile />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
            <Form.Item
                name="amountRial"
                label="هزینه ثبت نام (ریال)"
                rules={[
                  {
                    required: true,
                    message: "لطفا هزینه را وارد کنید!",
                  },
                  {
                    pattern: /^[0-9]+$/,
                    message: "لطفا هزینه را به طور صحیح وارد کنید",
                  },
                ]}
                validateStatus={error && "error"}
              >
                <InputNumber
                  formatter={(value) =>
                    value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                  className="form-input"
                  placeholder={"هزینه"}
                  style={{ textAlign: "left", width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
            <Form.Item
                name="strikethroughRial"
                label="قیمت خط خورده (ریال)"
                rules={[
                  {
                    pattern: /^[0-9]+$/,
                    message: "لطفا قیمت را به طور صحیح وارد کنید",
                  },
                ]}
                validateStatus={error && "error"}
              >
                <InputNumber
                  formatter={(value) =>
                    value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                  className="form-input"
                  placeholder={"قیمت خط خورده"}
                  style={{ textAlign: "left", width: "100%" }}
                />
              </Form.Item>
            </Col>
      
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item label="توضیحات" name="description">
                <Input.TextArea rows={2} placeholder="توضیحات" />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    );
};

export default ConsultationInputs;